// PostMessage 통신을 위한 타입 정의
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
// 메시지 송신자 클래스
export var PostMessageBridge = /*#__PURE__*/ function() {
    "use strict";
    function PostMessageBridge() {
        var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.parent, origin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '*';
        _class_call_check(this, PostMessageBridge);
        _define_property(this, "origin", void 0);
        _define_property(this, "target", void 0);
        _define_property(this, "listeners", new Map());
        this.target = target;
        this.origin = origin;
        this.setupListener();
    }
    _create_class(PostMessageBridge, [
        {
            key: "setupListener",
            value: function setupListener() {
                var _this = this;
                window.addEventListener('message', function(event) {
                    if (_this.origin !== '*' && event.origin !== _this.origin) {
                        return;
                    }
                    var _event_data = event.data, type = _event_data.type, data = _event_data.data;
                    if (!type) return;
                    var handlers = _this.listeners.get(type);
                    if (handlers) {
                        handlers.forEach(function(handler) {
                            return handler(data, event);
                        });
                    }
                });
            }
        },
        {
            // 메시지 전송
            key: "send",
            value: function send(type, data, _source) {
                this.target.postMessage({
                    type: type,
                    data: data,
                    source: _source || 'open-webui-chat',
                    timestamp: Date.now()
                }, this.origin);
            }
        },
        {
            // 메시지 수신 리스너 등록
            key: "on",
            value: function on(type, handler) {
                if (!this.listeners.has(type)) {
                    this.listeners.set(type, []);
                }
                this.listeners.get(type).push(handler);
            }
        },
        {
            // 리스너 제거
            key: "off",
            value: function off(type, handler) {
                var handlers = this.listeners.get(type);
                if (handlers) {
                    var index = handlers.indexOf(handler);
                    if (index > -1) {
                        handlers.splice(index, 1);
                    }
                }
            }
        },
        {
            // 모든 리스너 제거
            key: "destroy",
            value: function destroy() {
                this.listeners.clear();
            }
        }
    ]);
    return PostMessageBridge;
}();
// React Hook으로 사용하기 위한 헬퍼
import React from 'react';
export var usePostMessageBridge = function(target, origin) {
    var _React_useState = _sliced_to_array(React.useState(function() {
        return new PostMessageBridge(target, origin);
    }), 1), bridge = _React_useState[0];
    React.useEffect(function() {
        return function() {
            return bridge.destroy();
        };
    }, [
        bridge
    ]);
    return bridge;
};
// 전역 브리지 인스턴스 (싱글톤)
export var globalBridge = new PostMessageBridge();
// 테마 동기화 헬퍼
export var syncTheme = function(_bridge, theme) {
    // CSS 변수 업데이트
    document.documentElement.style.setProperty('--theme-mode', theme);
    document.documentElement.setAttribute('data-theme', theme);
// 부모에게 테마 변경 알림 (타입 추가 필요)
// bridge.send('openwebui:theme-changed', { theme });
};
// 에러 리포팅 헬퍼
export var reportError = function(bridge, error, context) {
    bridge.send('openwebui:error', {
        error: error.message,
        details: {
            stack: error.stack,
            context: context,
            timestamp: new Date().toISOString()
        }
    });
};
